// 活动生命周期状态
export const CAMPAIGN_STATUS = {
  NOT_STARTED: 0,
  IN_PROGRESS: 1,
  EXPIRED: -1,
  DISABLED: -2,
}

// 活动状态筛选项
export const CAMPAIGN_STATUS_OPTIONS = [
  { label: '未开始', value: 0 },
  { label: '进行中', value: 1 },
  { label: '已过期', value: -1 },
  { label: '已失效', value: -2 },
]

// 活动绑定交互模式（组件内部 UI 状态）
export const BIND_TYPE = {
  NONE: 0,
  SELECT: 1,
  CREATE: 2,
}
